import { utilityTariffRowOwnedByOrg } from '../common'

export type UtilityTariffCatalogueRow = {
  is_public_read_only?: boolean | string | number | null
  org_id?: number | string | null
  org?: string
}

export const isPublicReadOnlyUtilityTariff = (record: unknown): boolean => {
  const value = (record as UtilityTariffCatalogueRow | null | undefined)?.is_public_read_only
  return value === true || value === 'true' || value === 1 || value === '1'
}

/** OpenSolar-managed catalogue row for the current org (lock icon). */
export const utilityTariffCatalogueRowIsManaged = (
  record: unknown,
  orgId: number | string | null | undefined
): boolean => isPublicReadOnlyUtilityTariff(record) && !utilityTariffRowOwnedByOrg(record, orgId)
